<template>
    <div class="flex flex-col gap-6">
        <h2 class="text-2xl md:text-4xl font-semibold">Genetic Test Results</h2>

        <div>
            <h3 class="text-base md:text-2xl font-semibold mb-3">Genetic test results<sup>1</sup></h3>

            <ul class="list-disc pl-4 font-light">
                <li>
                    <span class="text-lightblue italic">AGXT</span> gene sequencing revealed a homozygous alteration in
                    exon 8 (c.799A>T) that resulted in isoleucine to phenylalanine substitution in the protein sequence
                    (p.[IIe267Phe])
                </li>
                <li>
                    Literature recommends to offer genetic counseling to patients with PH and their families<sup>2</sup>
                </li>
            </ul>
            <button
                class="bg-green py-4 px-8 mt-8 shadow rounded-full text-center text-gray-800 font-semibold text-sm flex items-center justify-center gap-2 flex-grow sm:flex-grow-0"
                @click="$emit('openModalForAdolescentScreening')"
            >
                <span>Click to explore the family screening</span>
                <img class="inline-block h-4 w-4 font-semibold" src="@/assets/img/plus.svg" alt="Plus Icon" />
            </button>
        </div>

        <h2 class="text-2xl md:text-3xl font-semibold text-center">
            Algorithm for Diagnostic Evaluation of PH – Genetic Testing<sup>2–4</sup>
        </h2>

        <img
            src="@/assets/img/graphics/adolescent/genetic-testing-desktop.svg"
            alt="Genetic Testing"
            class="hidden sm:block"
        />
        <img
            src="@/assets/img/graphics/adolescent/genetic-testing-mobile.svg"
            alt="Genetic Testing"
            class="sm:hidden"
        />

        <h3 class="text-base md:text-2xl font-semibold mb-3 p-6 bg-lightblue50 text-center">
            Genetic confirmation of PH1?<sup>1</sup> Yes
        </h3>
    </div>
</template>

<script setup>
defineEmits(['openModalForAdolescentScreening']);
</script>
